import { c as _c } from "react/compiler-runtime";
import { useDonate } from '../donate-context.tsx';
import { useDonateValidation } from '../hooks/use-donate-validation.tsx';
export const DonateImpactText: React.FC = () => {
  const $ = _c(6);
  const {
    state,
    props
  } = useDonate();
  const {
    getCurrentAmount
  } = useDonateValidation();
  const frequencyAmounts = props?.fund?.[`suggestedAmounts${state.donateFrequency}`];
  let t0;
  if ($[0] !== frequencyAmounts || $[1] !== getCurrentAmount) {
    t0 = frequencyAmounts?.find(e => e.value.toString() === getCurrentAmount())?.impact;
    $[0] = frequencyAmounts;
    $[1] = getCurrentAmount;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const impactText = t0;
  let t1;
  if ($[3] !== impactText || $[4] !== state) {
    t1 = impactText && !state.otherSelected ? <p>{impactText}</p> : null;
    $[3] = impactText;
    $[4] = state;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};